import { ScrollTrigger } from "gsap/all";
import _ from "underscore";

export default class Header {

  constructor() {
    this.html = document.querySelector('html');
    this.header = document.querySelector('.header');
    this.lastScrollTop = 0;
    this._measuring = false;
    this._lastObservedHeight = 0;

    if (!this.header) return;

    window.addEventListener('scroll', () => {
      this.scrollHandler();
    });
    this.scrollHandler();

    // Keep --header-height / --header-height-flat in sync with the header's
    // real rendered height. A ResizeObserver fires on observe() and on every
    // size change (has-scrolled toggle, viewport resize, web-font swap), so
    // scroll-margin offsets and layout padding always match the current
    // header. The header lives outside the Barba container, so this survives
    // page transitions without needing to re-run on navigation.
    this.resizeObserver = new ResizeObserver(() => {
      if (this._measuring) return;
      // ignore the resize notifications our own class toggling produces
      if (this.header.offsetHeight === this._lastObservedHeight) return;
      this.syncHeights();
    });
    this.resizeObserver.observe(this.header);

    const resizeHandler = _.debounce(() => {
      this.syncHeights();
      ScrollTrigger.refresh();
    }, 100);
    window.addEventListener('resize', resizeHandler);

    this.syncHeights();
  }

  // Measure both header states and expose them as custom properties.
  // --header-height stays the expanded height so the main content's top
  // padding does not jump when the header shrinks on scroll;
  // --header-height-flat is the collapsed height used by sticky elements
  // (rooms, teaser-rooms, lsb-stacked).
  syncHeights() {
    if (this._measuring || !this.header) return;
    this._measuring = true;

    const wasScrolled = this.header.classList.contains('has-scrolled');

    // disable all transitions inside the header while measuring both states
    this.header.classList.add('is-measuring');

    this.header.classList.remove('has-scrolled');
    this.html.style.setProperty('--header-height', this.header.offsetHeight + 'px');

    this.header.classList.add('has-scrolled');
    this.html.style.setProperty('--header-height-flat', this.header.offsetHeight + 'px');

    // restore previous state and flush styles before re-enabling transitions,
    // otherwise the restore itself would animate
    this.header.classList.toggle('has-scrolled', wasScrolled);
    void this.header.offsetHeight;
    this.header.classList.remove('is-measuring');

    this._lastObservedHeight = this.header.offsetHeight;
    this._measuring = false;
  }

  scrollHandler() {
    this.header.classList.toggle('has-scrolled', this.html.scrollTop > this.header.clientHeight - 40);
  }
}
